import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	loginTitle: {
		id: 'guestPass.redeem.title.login',
		defaultMessage: 'Log into your account',
		description: 'Invitation to a user to log into their Calm account',
	},
	signupTitle: {
		id: 'guestPass.redeem.title.signup',
		defaultMessage: 'Create your Calm Account',
		description: 'Invitation to a user to create a Calm account',
	},
	guestPassTitle: {
		id: 'guestPass.redeem.title.guestPass',
		defaultMessage: 'Redeem Guest Pass',
		description: 'Invitation to a user to redeem a guest pass',
	},
	continue: {
		id: 'guestPass.redeem.continue',
		defaultMessage: 'Continue',
		description:
			'Button for a user to continue to the next screen to either log in or sign up for a Calm account',
	},
	redeemCopy: {
		id: 'generics.redeem',
		defaultMessage: 'Redeem',
		description: 'Heading for redeem page',
	},
	alreadySubscribedTitle: {
		id: 'guestPass.redeem.alreadySubscribed.title',
		defaultMessage: "You're already a Subscriber",
		description: 'Heading for a section about how the user is already a subscriber',
	},
	alreadySubscribedSubtitle1: {
		id: 'guestPass.redeem.alreadySubscribed.subtitle1',
		defaultMessage: 'It looks like you already subscribe to Calm.',
		description: 'Message to the user saying that they are already a subscriber',
	},
	alreadySubscribedSubtitle2: {
		id: 'guestPass.redeem.alreadySubscribed.subtitle2',
		defaultMessage: 'No need for a {trialLength}-Day Guest Pass.',
		description: 'Message to the user that ',
	},
	alreadySubscribedCta: {
		id: 'guestPass.redeem.alreadySubscribed.cta',
		defaultMessage: 'Start using Calm',
		description: 'Button for user to start using Calm',
	},
	alreadyFreeTrialedTitle: {
		id: 'guestPass.redeem.alreadyFreeTrialed.title',
		defaultMessage: "You've already had a free trial",
		description: 'Heading for section about how a user has already had a free trial to Calm',
	},
	alreadyFreeTrialedSubtitle1: {
		id: 'guestPass.redeem.alreadyFreeTrialed.subtitle1',
		defaultMessage: "It looks like you've already had a free trial to Calm.",
		description: 'Message to user saying that the user has already had a free trial to Calm',
	},
	alreadyFreeTrialedCta: {
		id: 'guestPass.redeem.alreadyFreeTrialed.cta',
		defaultMessage: 'Get Calm Premium',
		description: 'Heading for a section about getting Calm Premium',
	},
	invalidCodeTitle: {
		id: 'guestPass.redeem.invalidCode.title',
		defaultMessage: 'Invalid Guest Pass',
		description: 'Message that guest pass is invalid',
	},
	createOrLogin: {
		id: 'guestpass.subtitle.createOrLogin',
		defaultMessage: 'Log In or Sign Up',
		description: 'Invitation to log in or sign up in order for a user to claim their 30-day guest pass',
	},
	createAccount: {
		id: 'guestPass.redeem.subtitle.createAccount',
		defaultMessage: 'Log in or Sign Up to claim your 30-day Calm Guest Pass.',
		description: 'Invitation to log in or sign up in order for a user to claim their 30-day guest pass',
	},
	loggedIn: {
		id: 'guestPass.redeem.subtitle.loggedIn',
		defaultMessage: "Claim your 30-day Calm Guest Pass and get access to Calm's entire library of content.",
		description:
			"Notice for a user to claim their 30-day guest pass and thus get access to Calm's entire library of content",
	},
	title: {
		id: 'guestPass.title',
		defaultMessage: 'Claim your {trialLength}-Day Guest Pass from {sender}',
		description: 'Notice to a user to claim their guest pass',
	},
	terms3: {
		id: 'login.terms3',
		defaultMessage: 'Your use of Calm is subject to our {terms} and {privacyPolicy}.',
		description: 'Message that a user of Calm is subject to its terms and privacy policy',
	},
	terms: {
		id: 'guestPass.terms',
		defaultMessage: 'Terms',
		description: 'A link to our Terms page',
	},
	privacyPolicy: {
		id: 'generics.PrivacyPolicy',
		defaultMessage: 'Privacy Policy',
		description: 'A link to our Privacy Policy page',
	},
	invalidCode: {
		id: 'guestPass.invalidCodeTitle',
		defaultMessage: 'Invalid Code',
		description: 'Heading for invalid code error message',
	},
	invalidCodeSubtitle: {
		id: 'guestPass.invalidCodeSubtitle',
		defaultMessage: 'The guest pass code you have entered is invalid.',
		description: 'Error message for invalid code',
	},
});
